import React, {Component} from 'react';
import {
    Button,
    FormControl,
    Popover
} from '@sketchpixy/rubix';
import * as _ from "lodash";
import moment from 'moment';
import {UserActions} from '../reducers/user/index'
import connect from "react-redux/es/connect/connect";
import {DEFAULT_DATE_TIME_FORMAT, APPROVED, PENDING, NOT_REQUIRED, INVITED, NOT_PROVIDED, DEFAULT_USER_IMAGE, ADMIN_ROLE} from "../utils/index";

class UserListItem extends Component {
    constructor(props) {
        super(props)
        this.state = {user: props.user, show: false}
    }

    componentDidMount() {
        const {user = {}} = this.props
        this.setState({user})
    }

    goToDetail = () => {
        const {goToDetail} = this.props;
        const {user} = this.state;
        goToDetail(user);
    }

    test = (user) => {
        // alert(JSON.stringify(user))
        user.popShow=!user.popShow
        // const {show} = this.state;
        this.setState({user: user})
    }

    selectBackground = () => {
        const {user} = this.state;
        const _user = _.cloneDeep(user);
        _user.backgroundCheckStatus = NOT_REQUIRED
        this.props.updateUserInfo({
            id: _user.id,
            backgroundCheckStatus: _user.backgroundCheckStatus,
        })
        this.setState({user: _user})
    }

    render() {
        const {UserRoleType} = this.props;
        const {user, show} = this.state;
        
        // find at least 1 approved vehicle
        // TODO: will change this logic on later stages when there are more than 1 vehicle allowed to add
        

        return (
            <tr key={`${UserRoleType}-${user.id}`}>
                {/* <td>
                    <img
                        src={user.picture && user.picture.url ? user.picture.url : DEFAULT_USER_IMAGE}
                        className='list-img-circle '/>
                </td> */}
                <td></td>
                <td>
                    <Button
                        className='name-list-info'
                        bsStyle='link'
                        style={{fontWeight: 'bold'}}
                        onClick={
                            this.goToDetail
                        }>
                        {
                            `${user.name.first} ${user.name.last}`
                        }
                    </Button>
                </td>
                <td className={user.email ? APPROVED : PENDING}>{user.email ? user.email : ""}</td>
                {/* <td className={user.companyName ? APPROVED : PENDING}>{user.companyName ? user.companyName : ""}</td> */}

                <td className={user.npi ? APPROVED : PENDING}>{user.npi ? user.npi : ""}</td>
                <td className={user.role === ADMIN_ROLE ? APPROVED : PENDING}>{user.role === ADMIN_ROLE ? "Doctor" : ""}</td>
                {/* <td>{user.createdAt ?
                    moment(user.createdAt).format(DEFAULT_DATE_TIME_FORMAT)
                    : NOT_PROVIDED}
                </td> */}
                <td>
                    <div>
                        <p onClick={e => this.test(user)}>...</p>
                        <div className='popover__wrapper'>
                            <div className={!user.popShow ? 'popover__before': 'popover__after'}>
                                <div>AAAA</div>
                                <div>BBBB</div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

        );
    }
}

const
    mapStateToProps = state => ({
                                    user: {specific: {fetching, isUserUpdate, error = undefined} = {}}
                                }) => {
        return {fetching, isUserUpdate, error}
    };

const mapDispatchToProps = dispatch => ({
    updateUserInfo: (user) => {
        dispatch(UserActions.updateSpecificUserRequest(user))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(UserListItem)